import { StyleValue } from "vue";
import { BFilterableField } from "../BFilterEditor/BFilterEditor.types";

export interface BTableColumn {
    key: any;
    text: string;
    sortable: boolean;
    filterable?:BFilterableField | undefined;
    columnType?: "primary" | "secondary" | "tertiary";
    columnStyle?: StyleValue;
    columnClass?: string[];
    style?: (item: any) => StyleValue;
    class?: (item: any) => string[];
    value?: (item: any) => any;
}

export interface BSortOptions {
    key: string;
    isDescending: boolean;
}

export interface BTableOptions {
    totalItemCount: number;
    itemsPerPage: number;
    page: number;
    sortBy: BSortOptions[];
    pagingMode?: "withTotal" | "noTotal" | undefined;
}

export function serializeSortBy(sortBy: BSortOptions[]): string {
    return sortBy.map(it => `${it.isDescending ? "-" : "+"}${it.key}`).join(",");
}

export function serializeTableOptionsForQueryString(tableOptions:BTableOptions){
    let json = JSON.stringify(tableOptions);
    return btoa(json);
}

export interface BSelectOptionsNumber {
    text: string;
    value: number;
}
